//to create Access Profiles

export const CREATE_ACCESSPROFILE_START = "CREATE_ACCESSPROFILE_START";
export const CREATE_ACCESSPROFILE_FAILURE = "CREATE_ACCESSPROFILE_FAILURE";
export const CREATE_ACCESSPROFILE_SUCCESS = "CREATE_ACCESSPROFILE_SUCCESS";
export const CREATE_ACCESSPROFILE_RESET = "CREATE_ACCESSPROFILE_RESET";


// to get created profiles


export const GET_ACCESSPROFILE_START = "GET_ACCESSPROFILE_START";
export const GET_ACCESSPROFILE_FAILURE = "GET_ACCESSPROFILE_FAILURE";
export const GET_ACCESSPROFILE_SUCCESS = "GET_ACCESSPROFILE_SUCCESS";
export const GET_ACCESSPROFILE_RESET = "GET_ACCESSPROFILE_RESET";


// to get Routes


export const GET_ROUTES_START = "GET_ROUTES_START";
export const GET_ROUTES_FAILURE = "GET_ROUTES_FAILURE";
export const GET_ROUTES_SUCCESS = "GET_ROUTES_SUCCESS";
export const GET_ROUTES_RESET = "GET_ROUTES_RESET";

 // Assign profiles to and employee
 
export const ASSIGN_ROUTES_START = "ASSIGN_ROUTES_START";
export const ASSIGN_ROUTES_FAILURE = "ASSIGN_ROUTES_FAILURE";
export const ASSIGN_ROUTES_SUCCESS = "ASSIGN_ROUTES_SUCCESS";
export const ASSIGN_ROUTES_RESET = "ASSIGN_ROUTES_RESET";


// to get Assigned Routes of specific employee


export const GET_EMPROUTES_START = "GET_EMPROUTES_START";
export const GET_EMPROUTES_FAILURE = "GET_EMPROUTES_FAILURE";
export const GET_EMPROUTES_SUCCESS = "GET_EMPROUTES_SUCCESS";
export const GET_EMPROUTES_RESET = "GET_EMPROUTES_RESET";

// to get Employees for Access

export const GET_ACCESSEMPLOYEE_START = "GET_ACCESSEMPLOYEE_START";
export const GET_ACCESSEMPLOYEE_FAILURE = "GET_ACCESSEMPLOYEE_FAILURE";
export const GET_ACCESSEMPLOYEE_SUCCESS = "GET_ACCESSEMPLOYEE_SUCCESS";
export const GET_ACCESSEMPLOYEE_RESET = "GET_ACCESSEMPLOYEE_RESET";


export const UPDATE_ACCESSPROFILE_START = "UPDATE_ACCESSPROFILE_START";
export const UPDATE_ACCESSPROFILE_SUCCESS = "UPDATE_ACCESSPROFILE_SUCCESS";
export const UPDATE_ACCESSPROFILE_FAILURE = "UPDATE_ACCESSPROFILE_FAILURE";
export const UPDATE_ACCESSPROFILE_RESET = "UPDATE_ACCESSPROFILE_RESET";


export const GET_OTHER_ROUTES = "GET_OTHER_ROUTES"
export const GET_OTHER_ROUTES_SUCCESS = "GET_OTHER_ROUTES_SUCCESS"
export const GET_OTHER_ROUTES_FAILED = "GET_OTHER_ROUTES_FAILED"

export const GETMY_OTHER_ROUTES = "GETMY_OTHER_ROUTES"
export const GETMY_OTHER_ROUTES_SUCCESS = "GETMY_OTHER_ROUTES_SUCCESS"
export const GETMY_OTHER_ROUTES_FAILED = "GETMY_OTHER_ROUTES_FAILED"

export const UPDATE_OTHER_ROUTES = "UPDATE_OTHER_ROUTES"
export const UPDATE_OTHER_ROUTES_SUCCESS = "UPDATE_OTHER_ROUTES_SUCCESS"
export const UPDATE_OTHER_ROUTES_FAILED = "UPDATE_OTHER_ROUTES_FAILED"